import { IssuanceContributingItem } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<IssuanceContributingItem>[] = [{
  title: 'ID',
  dataIndex: 'id',
}, {
  title: 'SKU',
  dataIndex: 'sku',
}, {
  title: 'Name',
  dataIndex: 'name',
}, {
  title: 'Category Id',
  dataIndex: 'categoryId',
}, {
  title: 'Quantity',
  dataIndex: 'quantity',
}, {
  type: TColumn.type.Currency,
  title: 'Price',
  dataIndex: 'price',
}, {
  type: TColumn.type.Currency,
  title: 'Total',
  dataIndex: 'total',
}];
